/* eslint import/no-extraneous-dependencies: 0 */
/* eslint camelcase: 0 */

// Blockly registra sus generadores built-in en el singleton de blockly/javascript, no en
// el prototipo, así que nuestra subclase arranca con forBlock vacío. Se toman prestados
// del singleton en vez de reescribirlos: reciben nuestro generador y usan sus ORDER_*.

import { javascriptGenerator } from 'blockly/javascript';

const prestado = (type) => (block, generator) => javascriptGenerator.forBlock[type](block, generator);

export const logic_boolean = prestado('logic_boolean');
export const logic_null = prestado('logic_null');
export const math_single = prestado('math_single');

export const controls_for = prestado('controls_for');
